export interface EditorHandle {
  getValue(): string;
  setValue(value: string): void;
  onChange(callback: (value: string) => void): void;
}

export interface EditorOptions {
  debounceMs?: number;
}

export function attachEditor(
  textarea: HTMLTextAreaElement,
  opts: EditorOptions = {},
): EditorHandle {
  const debounceMs = opts.debounceMs ?? 200;
  const listeners: Array<(value: string) => void> = [];
  let timer: ReturnType<typeof setTimeout> | null = null;

  function emit(value: string): void {
    for (const l of listeners) l(value);
  }

  textarea.addEventListener('input', () => {
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      emit(textarea.value);
    }, debounceMs);
  });

  return {
    getValue() {
      return textarea.value;
    },
    setValue(value: string) {
      textarea.value = value;
      // setValue is treated as a deliberate, synchronous change → fire immediately,
      // and cancel any pending debounced input emit so we don't double-fire.
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
      emit(value);
    },
    onChange(callback) {
      listeners.push(callback);
    },
  };
}
